import dayjs from "dayjs";
import { TFunction } from "i18next";
import {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PageHead from "../../../components/PageHead";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import AddCategoryProduct from "./AddModal";
import CategoryOptionModal from "./OptionsModal";
import SearchTable from "../../../components/SearchTable";
import {SortParams, TableColumn } from "../../../components/Table";

const getColumns = (t: TFunction<any>) : TableColumn[] =>[
  {
    Header: t("NAME"),
    accessor: "name",
    isSortable: true,
  },
  {
    Header: t("SUBCATEGORIES"),
    accessor: "subcategories_short",
  },
  {
    Header: t("CREATED_AT"),
    accessor: "createdAt",
    isSortable: true,
  },
  {
    Header: t("UPDATED_AT"),
    accessor: "updatedAt",
    isSortable: true,
  },

];

interface Category {
  id: string
  name: string
  isDeleted: boolean
  createdAt: string
  updatedAt: string
  subCategories: Category[]
}

export interface FormatedCategory extends Category {
  createdAt: string
  updatedAt: string
  subcategories_short: string
}

type FetchListApiResponse = Category[];

const CategoriesPage = () => {
  const { t } = useTranslation("translations");
  const [length, setLength] = useState<number>(0);
  const [fData, setFData] = useState<FormatedCategory[]>([]);
  const [resetFilter, setResetFilter] = useState<boolean>(false);
  const [originalRes, setOriginalRes] = useState<FetchListApiResponse>([]);
  const [addModal, setAddModal] = useState<boolean>(false);
  const [setectedEntry, setSelectedEntry] = useState<FormatedCategory | null>(null);
  
  // Table pagination
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search, setSearch] = useState<string>("");
  const [sortParmas, setSortParams] = useState<SortParams | null>(null);
  
  const resetFilters = () => {
    if(page === 1 && perPage === 10 && search === "") {
      fetchData(1, 10, "", null);
    } else {
      setPage(1);
      setPerPage(10);
      setSearch("");
      setSortParams(null);
    }
  }
  
  const fetchData = async (
      currentPage: number = 1,
      perPage: number = 10,
      search: string | undefined,
      sortParams: SortParams | null
  ) => {
    try {
      const res = await getAxiosInstance().get('/Categories', { params: {
          PageNumber: currentPage,
          PageSize: perPage,
          SearchString: search,
          SearchField: search ? "Name" : undefined,
          SortBy: sortParams ? sortParams.sortBy : undefined,
          SortDesc: sortParams ? sortParams.isSortedDesc : undefined
        }});

      const paginationData = JSON.parse(res.headers.pagination);
      setLength(paginationData.totalItems);
      setOriginalRes(res.data);
      setFData(formatData(res.data, (paginationData.currentPage - 1) * paginationData.itemsPerPage));
    } catch (e) {
      console.log(e);
      toast.error(
        t("SOMETHING_WENT_WRONG"),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
    }
  };
  
  const formatData = (data: FetchListApiResponse, length: number = 0): FormatedCategory[] => {
    const f_data: FormatedCategory[] = [];
    
    for(const a of data) {
      let subcategories_short = "";
      for(const x of a.subCategories) {
        subcategories_short += x.name + ", ";
      }
      
      if(subcategories_short.length > 0) {
        subcategories_short = subcategories_short.slice(0, -2);
      } 
      
      f_data.push({
        ...a,
        createdAt: dayjs(a.createdAt).format("DD-MM-YYYY hh:mm"),
        updatedAt: dayjs(a.updatedAt).format("DD-MM-YYYY hh:mm"),
        subcategories_short: subcategories_short
      })
    }
    return f_data;
  }
  
  return (
    <div>
      <PageHead 
        name={t("CATEGORIES")}
        addTooltip={t("ADD_CATEGORIES")} 
        onAddModal={() => setAddModal(true)}
      />
      <SearchTable
        columns={getColumns(t)}
        data={fData}
        dataLength={length}
        onRowClick={(data) => setSelectedEntry(data)}
        fetchData={(data) => fetchData(data.page, data.perPage, data.searchTerm, data.sortParams)}
        page={page}
        perPage={perPage}
        setPage={setPage}
        setPerPage={setPerPage}
        search={search}
        setSearch={setSearch}
        sortParams={sortParmas}
        setSortParams={setSortParams}
      />
      <AddCategoryProduct
        isOpen={addModal}
        onClose={() => {
          resetFilters();
          setAddModal(false)
        }}
      />
      <CategoryOptionModal
        isOpen={setectedEntry !== null}
        data={setectedEntry}
        onClose={() => {
          resetFilters();
          setSelectedEntry(null);
        }}
      />
    </div>
  )
};

export default CategoriesPage;